import timeUtils from '@/utils/time.utils'
import timelineConstants from './EquipmentMaintenanceTable/components/Timeline/timeline.constants'

const isDateInMaintenancePeriod = (eventDate: Date) => {
  const start = timeUtils.subDays(eventDate, timelineConstants.maintenanceGracePeriod)
  const end = timeUtils.addDays(eventDate, timelineConstants.maintenanceGracePeriod)
  return {
    isDateInGracePeriod: timeUtils.isWithinInterval(Date.now(), { start, end }),
    start,
    end,
  }
}

const maintenanceUtils = { isDateInMaintenancePeriod }

export default maintenanceUtils
